import { z } from "zod";
import { DecimalAssertionError } from "@goodfill/decimal";
import { DateTime } from "luxon";

export const zISODateTime = (message: string = "ISO is not valid DateTime") =>
  z.string().transform((value, ctx) => {
    try {
      const dateTime = DateTime.fromISO(value);

      if (!dateTime.isValid) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message,
        });

        return z.NEVER;
      }

      return dateTime;
    } catch (e) {
      if (e instanceof DecimalAssertionError) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: e.message,
        });

        return z.NEVER;
      }

      throw e;
    }
  });

export const zDateTime = z.custom<DateTime>((val) => val instanceof DateTime);
